<template>
  <div class="statistics">
    <div class="flex-row flex-nowrap" style="margin-left: 400px">
      <div class="flex-row flex-nowrap flex-block justify-content-end m-b-xs" style="z-index: 9">
        <el-popover placement="bottom" trigger="click" popper-class="r-popover">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <br />
          <el-checkbox v-for="(column, index) in tableColumn" v-model="column.visible" :key="index" @change="_checkChange">{{column.label}}</el-checkbox>
          <!-- <RIcon slot="reference" title="设置数据项" name="dataSetting"/> -->
          <el-button  type="primary" size="mini" slot="reference"  name="dataSetting" style="margin-right: 10px;">设置数据项</el-button>
        </el-popover>
        <!--<el-button size="mini"  type="primary" slot="reference"  name="dataSetting" style="margin-left: 10px;" @click="handlePatchDelete">注销</el-button>-->
        <el-button size="mini"  type="primary" slot="reference"  name="dataSetting" @click="importFile">导入</el-button>
        <el-button size="mini"  type="primary" slot="reference"  name="dataSetting" @click="exportData">导出</el-button>
      </div>
    </div>
    <r-table
      :ref="tableVarity"
      :columns="tableColumn"
      :dataSource="tableData"
      :options="options"
      :pagination="pagination"
      @current-change="handlePageChange"
      @row-click="handleRowClick"
    ></r-table>

    <!--查看-->
    <RModal title="实际入住人详情" v-model="detailModal" @change="detailModal = false"  @close="closeModel">
      <template slot="content">
        <detail-model :detailModal="detailModal" :delete_uuid="delete_uuid" :detailData="detailData" @showMore="showMore"></detail-model>
      </template>
    </RModal>

    <Modal modalTitle="上传文件" modalId="upload-form">
      <div class="form-horizontal flex-column">
        <div class="flex-row flex-wrap justify-content-center text-center">
          <el-upload class="upload-demo" :limit="1" drag action="" :auto-upload="false" :on-change='onFileChange' ref='upload'>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将表格文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">支持xls不超过10M</div>
          </el-upload>
        </div>
        <div class="flex-row flex-wrap justify-content-between">
          <div class="p-t-sm">
            <a :href="downloadUrl" download='名单表格模板' style="color: #18a689">下载表格模板</a>
          </div>
          <div class="form-group p-t-sm">
            <div class="text-right">
              <button class="btn btn-sm btn-primary" type="button" @click="submitUpload">确定</button>
              <button class="btn btn-sm btn-white" data-dismiss="modal">取消</button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import Vue from 'vue';
  import RModal from '@/components/common/RModal'
  import RTable from '@/components/common/RTable'
  import tableMix from '@/components/common/tableListMixin.js'
  import checkMix from '@/components/common/checkAll.js'
  import detailModel from './realPersonDetail'
  import { mapActions, mapGetters ,mapState} from 'vuex'
  export default {
    name: "realperson",
    mixins: [tableMix,checkMix],
    props: ['roomCode'],
    components:{
      RModal,RTable,detailModel
    },
    computed: { ...mapGetters({ menuPerms: 'getPermObj', }),
      ...mapState({
        user: state => state.common.user
      })},
    data(){
      /*'-实际入住人：人脸、*实际入住人、国籍、外文姓名、*民族、*证件种类、*证件号码、*房源编码、*房源名称、*来源平台单位编码、*来源平台、*订单编码、*登记时间、*入住时间、*离开时间、*更新时间
*/
      let columMap1 ={'人脸':'url','实际入住人':'name','国籍':'country','外文姓名':'foreignName','民族':'nation','证件种类':'certType','证件号码':'certCode','房源编码':'roomCode','房源名称':'roomName',
        '来源平台单位编码':'orgCode','来源平台':'roomPlatformName','订单编码':'orderCode','登记时间':'regTime','入住时间':'inTime','离开时间':'outTime','更新时间':'updateTime'}

      let sels = ['country','certType','nation']
      let inputs = []
      /**照片、*登记时间、*入住时间、*离开时间、*更新时间*/
      let texts = ['url','regTime','inTime','outTime','updateTime']
      /*实际入住人：人脸、实际入住人、民族、证件种类、证件号码、房源名称、来源平台、订单编码、登记时间、入住时间、离开时间、更新时间*/
      let visibleCols = ['url','name','nation','certType','certCode','roomName','roomPlatformName','orderCode','regTime','inTime','outTime','updateTime']

      let dictCol1 = ['certType','country','nation']
      let requiredCols = ['name','nation','certType','certCode','orgCode','roomPlatformName','roomCode','roomName','orderCode','regTime','inTime','outTime','updateTime']
      let minWidth1= 200
      let minWidthCols = {'orgCode':minWidth1,'updateTime':minWidth1,
      }
      let tableColumn = []
      let filtersSearch = {}
      let selOptions = {}
      let tmpObj = {}
      for(let key in columMap1){
        tmpObj = {
          prop: columMap1[key],
          label: key,
        }

        tableColumn.push(tmpObj)

        // tableColumn = _.concat(tableColumn,tmpObj)

      }

      let optionList = []
      tableColumn.length && tableColumn.forEach((tmpObj)=>{
        tmpObj.visible = visibleCols.indexOf(tmpObj.prop)>=0 ? true:false
        tmpObj.minWidth = minWidthCols[tmpObj.prop]?minWidthCols[tmpObj.prop]:150

        if(tmpObj.prop=='name'){
          tmpObj.render = (row, index, column) => {
            return <span><a onClick={this.handleShowDetail.bind(this, row)}>{row[column.prop]}</a></span>;
          }
        }else if(tmpObj.prop=='url'){
          tmpObj.render = (row, index, column) => {
            return <span><el-image class="normalElImage" src={row[column.prop]}></el-image></span>;
          }
        }else if(dictCol1.indexOf(tmpObj.prop)>=0){
          tmpObj.render = (row, index, column) => {
            let dictName = column.prop.replace('Code','')
            return <span>{row[dictName+'Name']}</span>;
          }
        }

        if(sels.indexOf(tmpObj.prop)>=0){
          filtersSearch[tmpObj.prop] = ''
          selOptions[tmpObj.prop] = []
          tmpObj.renderHeader = (row,{column,$index}) => {
            return this.renderHeaderSelFun(row,{column,$index},this.selOptions[tmpObj.prop])
          }
        }else if(texts.indexOf(tmpObj.prop)==-1){
          filtersSearch[tmpObj.prop] = ''
          tmpObj.renderHeader = (row,{column,$index}) => {
            return this.renderHeaderInputFun(row,{column,$index})
          }
        }
      })
      return{
        tableVarity:'real_person',
        tabsArr: [
        ],
        loading:false,
        downloadUrl:'',
        deleteUrl:'ROOM.REALVIRTUALPERSON_DELETE',
        areUOk: false,
        uploadParams: {},
        industryTypeList:[],
        businessTypeList:[],
        faRenCertTypeList:[],
        faRenCountryList:[],
        delete_uuid:0,
        dictCol1:[...dictCol1],
        requiredCols:[...requiredCols],
        detailData:{},
        filters:{
          search:{
            ...filtersSearch
          }
        },
        selOptions:{
          ...selOptions
        },
        /*options: {
          multiSelect: false, // 多选
          serialNum: false, // 显示序号
          loading: false, // 加载中状态
          initTable: true, // 是否一挂载就加载数据
          height: 'calc(100vh - 295px)'
        },*/

        detailData:[],
        tableColumn: tableColumn,

      }
    },
    watch:{
    },
    mounted() {
      this.downloadUrl = window.axios.defaults.baseURL+'/commons/combobox/getImportTemplate?fileName=realCheckInPerson.xls'
    },
    created(){
      this.getInitDatas()
      this.initFilterSearch()
    },
    methods:{
      ...mapActions(['importUpload']),
      handleClick(){},
      // 如果url有参数则初始化查询参数
      initFilterSearch() {
        let params = this.$route.query
        if (params && params.certCode) {
          this.filters.search.certCode = params.certCode
          this.getQuery()
        }else if(this.roomCode){
          this.filters.search.roomCode = this.roomCode
          this.getQuery()
        } else {
          this.getDataList()
        }
      },
      getQueryParams(){
        let searches = {}
        for(let name in this.filters.search){
          if(this.filters.search[name]=='' ){
            continue;
          }
          let searchParam = this.filters.search[name]
          searches[name] = typeof searchParam === 'string' ? searchParam.trim() : searchParam
        }
        searches['isReal'] = 1
        if(this.toExcel==true ){
          if(this.options.selection.length){
            let ids = this.getProValues(this.options.selection)
            searches['ids'] = ids.join(',')
          }

          let cols = []
          let colsName = ['faRenCountry','faRenCertType','industryType','businessType','chanQuanRenCertType','chanQuanRenCountry','jingYinRenCertType','jingYinRenCountry','rentType','realCertType','realCountry','certType','nation','country']
          let colsCode = ['policeStaCode','provinceCode','cityCode','areaCode']
          let prop = ''
          if(this.tableVarity && this.tableColumn){
            this.tableColumn.map((item)=>{
              prop = item.property || item.prop
              if(colsName.indexOf(prop)>-1){
                prop = prop+'Name'
              }else if(colsCode.indexOf(prop)>-1){
                prop = prop.replace('Code','Name')
              }
              item.visible && cols.push(prop)
            })
          }
          searches['exportFiled'] = cols.join(',')
        }
        return {
          params:JSON.stringify(searches),
          start:(this.pagination.pageIndex-1)*this.pagination.pageSize,
          size:this.pagination.pageSize,
          toExcel:this.toExcel
        }
      },
      //列表
      getQuery(){
        this.options.loading = true
        let params = this.getQueryParams()

        let url =  'ROOM.REALVIRTUALPERSON_LIST'
        this.fetchData({
          url,
          method: 'get',
          params
        }).then(res => {
          this.options.loading = false
          if(this.toExcel==true){
            if( !res || !res.data) {
              this.$message.error('操作失败！')
            }else{
              window.location.href = res.data
            }
            this.toExcel = false
            return
          }

          if( !res || !res.data){
            this.tableData = []
            this.pagination.total = 0
          }else{
            this.tableData = res.data||[]
            this.pagination.total = res.count
          }
        }).catch((err)=>{
          console.log(err,'errorInfo')
        }).finally(()=>{
          this.options.loading = false
          this.toExcel = false
        })
      },

      getInitDatas(){
        let sels = {'nation':'nationality','certType':'cert_type','country':'country_code'}
        for(let selName in sels){
          this.getDctList(sels[selName]).then((ret)=>{
            this.selOptions[selName] = ret
          }).catch((err)=>{
            console.log(err,'dict err')
          })
        }
      },
      closeModel(){
        this.detailModal=false
      },
      showMore(name){
        this.detailModal=false
        for (let name in this.filters.search) {
          this.filters.search[name] = ''
        }
        this.filters.search['name'] = name
        this.handleSearch()
      },

      onFileChange(file, fileList) {
        let tailType = file.name.slice(file.name.lastIndexOf('.') + 1)
        let isType = ['xls'].indexOf(tailType) > -1
        let isSize = file.size / 1000 /1024 < 10
        if (!isType) {
          this.$refs.upload.clearFiles()
          this.alertToggle({
            alertType: 'danger',
            alertContent: '只能上传xls文件!'
          })
          return false
        }
        if (!isSize) {
          this.$refs.upload.clearFiles()
          this.alertToggle({
            alertType: 'danger',
            alertContent: '文件超过10MB'
          })
          return false
        }
        this.areUOk = true
        this.uploadParams = {
          file: file.raw,
          id: 'fileToUpload'
        }
      },
      submitUpload() {
        if (!this.areUOk) {
          this.alertToggle({
            alertType: 'danger',
            alertContent: '请先上传文件！'
          })
          return
        }
        let url = 'ROOM.REALVIRTUALPERSON_IMPORT'
        this.importUpload({
          url,
          params: this.uploadParams,
          postParams:{isReal:1},
        }).then(res => {
          if (res.failCount === 0) {
            this.alertToggle({
              alertType: 'success',
              alertContent: '导入成功！'
            })
            this.getDataList()
          } else {
            let tempArr = []
            Object.keys(res.data).forEach(item => {
              let msg = res.data[item].msg
              if (msg) {
                tempArr.push(`<p>${msg}</p>`)
              }
            })
            this.$alert(tempArr.join(''), '提示', {
              confirmButtonText: '确定',
              type: 'warning',
              center: true,
              dangerouslyUseHTMLString: true,
              customClass: 'messageBoxCustom',
              confirmButtonClass: 'btn-primary'
            })
          }
          $('#upload-form').modal('hide')
          this.areUOk = false
          this.$refs.upload.clearFiles()
          this._reloadData()
        }).catch(err => {
          $('#upload-form').modal('hide')
          this.alertToggle({
            alertType: 'danger',
            alertContent: err
          })
        })
      },
      importFile() {
        this.$refs.upload.clearFiles()
        $('#upload-form').modal('show')
      },
      handlePatchExport(){

      },
      handleShowDetail(row){
        this.$nextTick(()=>{
          this.detailModal = true
        })

        let data1 = []
        let data2 = []
        let data3 = []
        this.tableColumn.map((item,key)=>{
          let dictName = (this.dictCol1.indexOf(item.prop)>=0)?(item.prop.replace('Code', '')+'Name'):item.prop
          let className = this.requiredCols.indexOf(item.prop)>=0 ? 'required':''
          if(key<1) {
            data1.push({label:item.label,value:row[dictName]||'-',className:className})
          }
          else if(key<7) {
            data2.push({label:item.label,value:row[dictName]||'-',className:className})
          }else{
            data3.push({label:item.label,value:row[dictName]||'-',className:className})
          }
        })
        this.detailData = [data1,data2,data3]
      },
      handleDetailExport(row){
        if(!row.delete_uuid){
          return false
        }
        let param = {delete_uuid:row.delete_uuid,toExcel:true}

        this.fetchData({url:'WP.FIND_DELETE_SERVICE_DETAIL_LIST', method: 'post', params: param}).then((res)=>{
          window.location.href = res.zipUrl;
        }).finally(()=>{
        })
      },
      handlePatchDelete(){
        let ids = this.getProValues(this.options.selection)
        if(!ids.length){
          this.$message({ type: 'info', message: '请选择数据！' })
          return
        }
        this.$confirm(`确定要注销吗？`, { type: 'warning' }).then(() => {
          let params = {ids:JSON.stringify({ids:ids.join(',')})}
          this.fetchData({url:this.deleteUrl, method: 'post', params:params,timeout:0, isLoading:false, flag:true}).then((res)=>{
            if(res.status==1){
              this.$message.success('操作成功！')
              this.getDataList()
            }else{
              this.$message.error(res.msg||'操作失败！')
            }
          }).catch((err)=>{
            console.log(err,'delete err')
          })
        }).catch(() => false)


      },
    },
  }
</script>


